import request from '@/utils/request'

export default {
  // 主页接口
  index: params => {
    return request({
      url: '/index',
      method: 'GET',
      params
    })
  },
  //资讯接口
  consult: params => {
    return request({
      url: '/consult',
      method: 'GET',
      params
    })
  },
  // 咨询类型详情
  consultInfo: params => {
    return request({
      url: '/consult/Info',
      method: 'GET',
      params
    })
  },
  // 咨询类型详情 文章列表
  consultList: params => {
    return request({
      url: '/consult/List',
      method: 'POST',
      params
    })
  },
  // 培训接口
  train: params => {
    return request({
      url: '/train',
      method: 'GET',
      params
    })
  },
  // 历史开课列表
  trainList: params => {
    return request({
      url: '/train/List',
      method: 'POST',
      params
    })
  },
  // 金合资本
  jinHe: params => {
    return request({
      url: '/jinHe',
      method: 'POST',
      params
    })
  },
  // 金合创投详情
  jinHedetail: params => {
    return request({
      url: '/jinHe/detail',
      method: 'POST',
      params
    })
  },
  // 路演视频
  jinHelist: params => {
    return request({
      url: '/jinHe/list',
      method: 'POST',
      params
    })
  },
  // 金合创投推荐
  jinHetList: params => {
    return request({
      url: '/jinHe/tList',
      method: 'POST',
      params
    })
  },
  // 专家团
  expert: params => {
    return request({
      url: '/expert',
      method: 'GET',
      params
    })
  },
  //老师详情
  expertInfo: params => {
    return request({
      url: '/expert/Info',
      method: 'GET',
      params
    })
  },
  // 顶部查询
  Search: params => {
    return request({
      url: '/index/Search',
      method: 'POST',
      params
    })
  },
  //友情链接
  Links: params => {
    return request({
      url: '/index/Links',
      method: 'GET',
      params
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/common.js